export enum TopicIdsEnum {
  AREA = 'arealinformasjon',
  FOREST = 'skogportal',
  GRANT_ZONES = 'sonerfordistriktstilskudd',
  LANDSCAPE = 'landskap',
  REIN_HERDING = 'reindrift',
  SOIL = 'jordsmonn',
  WILDLIFE = 'viltkart',
}
